import makeStyles from "@mui/styles/makeStyles";

const useQuickSearchStyles = makeStyles((theme) => ({
  root_QuickSearch: {
    display: "flex",
    position: "relative", // to absolutely position searchContainer based on root_QuickSearch
    [theme.breakpoints.down("md")]: { position: "inherit" }, // allows the searchbar to center at this breakpoint
  },
  searchContainer: {
    position: "absolute",
    right: 28,
    zIndex: 10,
    width: 380, // ALL WIDTHS HERE MUST MATCH inputBase WIDTHS (including breakpoints)
    [theme.breakpoints.down("md")]: {
      width: 400,
      top: 48,
      left: 0,
      right: 0,
      marginLeft: "auto",
      marginRight: "auto",
    },
    [theme.breakpoints.down("sm")]: { width: "90vw", top: 52 },
  },
  inputBase: {
    backgroundColor: theme.palette.background.paper,
    backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.09))", // matches ResultsContainer paper
    padding: theme.spacing(0, 1),
    height: 28,
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    width: 380, // ALL WIDTHS HERE MUST MATCH searchContainer WIDTHS (including breakpoints)
    [theme.breakpoints.down("md")]: { width: 400, height: 38 },
    [theme.breakpoints.down("sm")]: { width: "90vw" },
  },
  inputBase_NoResultsLoaded: { borderRadius: theme.shape.borderRadius },
  resultsContainer: {
    zIndex: 5,
    position: "absolute",
    width: "100%",
    height: "auto",
    maxHeight: "80vh",
    overflowX: "hidden",
    border: "rgba(0, 0, 0, 0.23) solid 1px",
    "&:last-child": { paddingBottom: theme.spacing(1) },
    [theme.breakpoints.down("md")]: { position: "relative" },
  },
  label: {
    padding: theme.spacing(1, 0.5, 0, 0.5),
    color: "#919191",
    textTransform: "uppercase",
    fontSize: 9,
    fontWeight: 800,
  },
  link: {
    userSelect: "none",
    msUserSelect: "none",
    MozUserSelect: "none",
    WebkitUserSelect: "none",
    WebkitTouchCallout: "none",
    WebkitTapHighlightColor: "transparent",
    textDecoration: "none",
  },
  resultItem: {
    padding: theme.spacing(0.5, 1, 0.5, 1),
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
  },
  resultText_Wrapper: { color: "#eee", paddingLeft: 4, whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
  resultText_Title: { whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
  resultText_Subtitle: {
    color: theme.palette.grey[500],
    fontSize: 12,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  poster: {
    height: 40,
    width: 26.66,
    borderRadius: theme.shape.borderRadius,
  },
  imageDefault: {
    color: "white",
    backgroundColor: "#808080cc",
  },
  slowQueryAlert: { padding: theme.spacing(1, 0, 0, 0.5), color: "red" },
  smartSearchUnaval: {
    fontStyle: "italic",
    lineHeight: 1.1,
    padding: theme.spacing(1, 0, 0, 0.5),
    color: theme.palette.grey[500],
    fontSize: theme.typography.caption.fontSize,
  },
}));

export default useQuickSearchStyles;
